import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { Button } from '../../components/ui/button';
import { Input } from '../../components/ui/input';
import { Label } from '../../components/ui/label';
import { Lock, Mail } from 'lucide-react';

const AdminLogin = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const { login } = useAuth();
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');

    const result = await login(email, password);
    
    if (result.success) {
      navigate('/admin');
    } else {
      setError(result.error);
    }
    
    setLoading(false);
  };

  return (
    <div className="min-h-screen bg-[#f8f9fa] flex items-center justify-center px-4" data-testid="admin-login-page">
      <div className="w-full max-w-md">
        <div className="bg-white shadow-lg p-8">
          {/* Logo */}
          <div className="text-center mb-8">
            <img 
              src="https://customer-assets.emergentagent.com/job_beeb63f4-f271-4462-96ad-3cfca96ff85b/artifacts/c5rpsa8q_division%20immobiliere.jpeg" 
              alt="G Division" 
              className="h-16 w-auto mx-auto mb-4"
            />
            <h1 className="font-['Playfair_Display'] text-2xl font-bold text-[#1e3a5f]">
              Administration
            </h1>
            <p className="text-gray-500 text-sm mt-2">
              Connectez-vous pour accéder au tableau de bord
            </p>
          </div>

          {/* Form */}
          <form onSubmit={handleSubmit} className="space-y-6">
            <div className="space-y-2">
              <Label htmlFor="email" className="text-[#1e3a5f] font-medium">
                Email
              </Label>
              <div className="relative">
                <Mail className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400" size={18} />
                <Input
                  id="email"
                  type="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  required
                  className="pl-10 rounded-none border-gray-300 focus:border-[#1e3a5f]"
                  placeholder="votre@email.com"
                  data-testid="admin-email-input"
                />
              </div>
            </div>

            <div className="space-y-2">
              <Label htmlFor="password" className="text-[#1e3a5f] font-medium">
                Mot de passe
              </Label>
              <div className="relative">
                <Lock className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400" size={18} />
                <Input
                  id="password"
                  type="password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  required
                  className="pl-10 rounded-none border-gray-300 focus:border-[#1e3a5f]"
                  placeholder="••••••••"
                  data-testid="admin-password-input"
                />
              </div>
            </div>

            {error && (
              <p className="text-red-500 text-sm text-center" data-testid="admin-login-error">
                {error}
              </p>
            )}

            <Button 
              type="submit"
              disabled={loading}
              className="w-full bg-[#1e3a5f] text-white hover:bg-[#162a45] rounded-none py-3 uppercase tracking-wider text-sm font-semibold"
              data-testid="admin-login-btn"
            >
              {loading ? (
                <span className="flex items-center justify-center gap-2">
                  <div className="w-4 h-4 border-2 border-white border-t-transparent rounded-full loading-spinner"></div>
                  Connexion...
                </span>
              ) : (
                'Se Connecter'
              )}
            </Button>
          </form>

          {/* Back to site */}
          <div className="mt-8 text-center">
            <a 
              href="/" 
              className="text-gray-500 hover:text-[#1e3a5f] text-sm transition-colors"
            >
              ← Retour au site
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AdminLogin;
